export const environment = {
  production: true,
  hmr: false,
  usercentrics: {
    settingsId: 'z1MEzaNS3nsTBE',  // settings ID from admin.usercentrics.eu
    enabled: true,
    autoblockerEnabled: false,      // Set to true if using autoblocker
    euModeEnabled: true          
  }
};
